/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionStatesEnum } from './subscriptionStatesEnum';


export interface SubscriptionResponse { 
    orgId?: string;
    subscriptionId?: string;
    subscriptionGroupId?: string;
    status?: SubscriptionStatesEnum;
    serviceDefinitionId?: string;
    billingAccountId?: string;
    billingEngine?: string;
    billingEngineSubscriptionId?: string;
    creationDateTime?: Date;
}
export namespace SubscriptionResponse {
}


